<template>
  <div class="test" v-if="component_done_loading">
    <test-topbar :testObj="test"></test-topbar>
    <div class="col-xs-12 right-container clarification">
      <div class="flex">
        <div class="col-xs-12 marginBottom20">
          <team-leadership
            :testObj="test"
            @isTeamLeader="processIsTeamLeader($event)"
          ></team-leadership>
        </div>
      </div>
      <div
        class="alert alert-primary align-items marginBottom20"
        v-if="test.clarificationStatus == 'released'"
      >
        <div>
          <i class="fa fa-info-circle marginRight8" aria-hidden="true"></i>Please note that your team is
          highlighted in
        </div>
        <div class="statusTag statusTagLightWarning subBtn marginLeft5">
          <i class="fa fa-users greyText marginRight8" aria-hidden="true"></i>Your team name
        </div>
      </div>
      <kr-panel :withFooter="false">
        <template slot="title">
          <div class="col-md-6">
            ALL CLARIFYING QUESTIONS ({{ clarified_questions.length }})
          </div>
        </template>
        <template slot="content">
          <div class="hidden-md hidden-lg marginBottom20">
            <template v-if="canEditClarifications">
              <button
                class="btn btn-primary subBtn"
                @click.prevent="openRequestModal(add_question)"
                aria-label="New Freestyle"
              >
                <i class="fas fa-plus marginRight8" aria-hidden="true"></i>NEW FREESTYLE
              </button>
            </template>
          </div>
          <div
            class="hidden-lg hidden-md mini-panel panel"
            v-for="(question, question_idx) in clarified_questions"
          >
            <div class="panel-heading">
              <template v-if="question._type == 'question'">
                Question {{ question.question_no }}
                <template v-if="question.studentAnswer.isBookmarked">
                  &nbsp;<i class="bookmarked fa fa-bookmark"></i>
                </template>
              </template>
              <template v-else> Freestyle </template>
            </div>
            <div class="panel-body">
              <div>
                <div v-if="question._type == 'question'">
                  <kr-math
                    class="marginTop10"
                    :input="question.question"
                    :safe="!question.questionIsHTML"
                  ></kr-math>
                  <div
                    class="marginTop10 fontBold blue pointer"
                    @click.prevent="openQuestionInfoModal(question)"
                    aria-label="Read More"
                  >
                    Read More<i class="fa fa-caret-right marginLeft8" aria-hidden="true"></i>
                  </div>
                </div>
                <div v-else>
                  <div class="alert alert-primary marginTop10">
                    <div>
                      <i class="fa fa-info-circle marginRight8" aria-hidden="true"></i>
                    </div>
                    &nbsp;
                    <span>
                      For freestyle clarification, you may type in any
                      clarifying questions OR vote for questions raised by other
                      teams if your team has a similar question about the test.
                    </span>
                    <div>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close Modal"
                      >
                        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="marginTop20" v-if="question._type == 'question'">
                <div class="control-label">Answers Choices In Sequence</div>
                <div
                  v-if="
                    question._type == 'question' &&
                      (question.studentAnswer.attempts
                        ? question.studentAnswer.attempts.length != 0
                        : false)
                  "
                  class="statusTag subBtn"
                  :class="{
                    tagCorrect: question.percent == 100,
                    tagPrimary:
                      question.percent >= 50 && question.percent < 100,
                    tagWarning: question.percent < 50 && question.percent > 0,
                    tagIncorrect: question.percent == 0,
                  }"
                >
                  <template
                    v-for="(key, idx) in question.studentAnswer.attempts"
                  >
                    {{ key }}&nbsp;
                  </template>
                </div>
                <template v-else> - </template>
              </div>
              <div class="marginTop20">
                <div class="flexSpaceBetween inlineFlex align-items">
                  <div class="control-label marginBottom0">
                    WE WOULD LIKE TO CLARIFY…
                  </div>
                  <button
                    v-if="
                      question._status != 'voted' &&
                        !(!question._status && !canEditClarifications)
                    "
                    class="btn btn-primary subBtn"
                    @click.prevent="openRequestModal(question)"
                    aria-label="Edit/View Request"
                  >
                    <template v-if="canEditClarifications">
                      <i v-if="question._status" class="fa fa-edit" aria-hidden="true"></i>
                      <template v-else> Request </template>
                    </template>
                    <template v-else>
                      <i v-if="question._status" class="fas fa-eye" aria-hidden="true"></i>
                    </template>
                  </button>
                </div>
                <template v-if="question._type == 'question'">
                  <div
                    class="flex align-items marginBottom20 col-xs-12 col-md-12"
                    v-if="
                      question.studentAnswer.attachments &&
                        question.studentAnswer.attachments.length != 0
                    "
                  >
                    <div class="col-xs-12">
                      <!-- <span style="font-weight:bold;">Uploaded Files</span> -->
                      <div
                        v-for="(file, idx) in question.studentAnswer
                          .attachments"
                        class="flexSpaceBetween"
                      >
                        <div>
                          <span>{{ idx + 1 }}.</span>
                          <span>
                            <i class="fa fa-file-image-o" aria-hidden="true"></i>
                          </span>
                          <a
                            :href="file.url"
                            target="_blank"
                            download
                            :aria-label="file.filename"
                            >{{ file.filename }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="question._type == 'freestyle'">
                  <div
                    class="flex align-items marginBottom20 col-xs-12 col-md-12"
                    v-if="
                      question.attachments && question.attachments.length != 0
                    "
                  >
                    <div class="col-xs-12">
                      <!-- <span style="font-weight:bold;">Uploaded Files</span> -->
                      <div
                        v-for="(file, idx) in question.attachments"
                        class="flexSpaceBetween"
                      >
                        <div>
                          <span>{{ idx + 1 }}.</span>
                          <span>
                            <i class="fa fa-file-image-o" aria-hidden="true"></i>
                          </span>
                          <a
                            :href="file.url"
                            target="_blank"
                            download
                            :aria-label="file.filename"
                            >{{ file.filename }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="question._type == 'question'">
                  <div class="heightMax100px">
                    {{ question.studentAnswer.clarifications }}
                  </div>
                </template>
                <template v-else>
                  <div class="heightMax100px">{{ question.freestyle }}</div>
                </template>
              </div>
              <div class="marginTop20" v-if="question._status">
                <div class="control-label">MY TEAM HAS…</div>
                <div class="fontBold flexOnly">
                  <i class="fa fa-check-circle textSuccess marginRight8" aria-hidden="true"></i>
                  <template v-if="question._status == 'requested'">
                    <span> Requested </span>
                  </template>
                  <template v-if="question._status == 'voted'">
                    <span> Voted </span>
                  </template>
                </div>
              </div>
              <div
                class="marginTop20"
                v-if="canEditClarifications && question._status"
              >
                <button
                  class="col-xs-12 btn btn-danger subBtn"
                  @click.prevent="removeClarifications(question)"
                  aria-label="Remove"
                >
                  Remove<i class="fa fa-trash marginLeft8" aria-hidden="true"></i>
                </button>
              </div>
              <div
                class="marginTop20"
                v-if="
                  question._type == 'question' &&
                    test.clarificationStatus == 'released'
                "
              >
                <div class="control-label">OTHER TEAM CLARIFICATIONS</div>
                <template
                  v-for="(request, request_idx) in question.otherClarifications"
                >
                  <div class="marginTop20">
                    <div class="col-xs-6 buttonGroup">
                      <button
                        class="btn gradient btn-default subBtn flex1"
                        @click.prevent="openTeamInfoModal(request)"
                        :aria-label="request.team"
                      >
                        {{ request.team }}
                      </button>
                      <button
                        v-if="
                          request.attachments && request.attachments.length != 0
                        "
                        class="btn gradient btn-default subBtn flex1"
                        @click.prevent="
                          openTeamAttachmentsModal({
                            name: request.team,
                            attachments: request.attachments,
                          })
                        "
                        aria-label="Team's Attachments"
                      >
                        <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>Team’s
                        Attachment(s)
                      </button>
                    </div>
                    <div class="marginTop10">
                      {{ request.clarifications }}
                    </div>
                  </div>
                </template>
                <template
                  v-if="
                    !question.otherClarifications ||
                      (question.otherClarifications &&
                        question.otherClarifications.length == 0)
                  "
                >
                  NO OTHER CLARIFICATIONS
                </template>
              </div>
              <div
                class="marginTop20"
                v-if="
                  question._type == 'freestyle' &&
                    test.clarificationStatus == 'released' &&
                    !question.isRequestedByMe
                "
              >
                <div class="control-label">TEAM WHO REQUESTED</div>
                <div class="marginTop20">
                  <div class="col-xs-6 buttonGroup">
                    <button
                      class="btn gradient btn-default subBtn flex1"
                      @click.prevent="openTeamInfoModal(question.requestedBy)"
                      :aria-label="question.requestedBy.name"
                    >
                      {{ question.requestedBy.name }}
                    </button>
                    <button
                      v-if="
                        question.attachments && question.attachments.length != 0
                      "
                      class="btn gradient btn-default subBtn flex1"
                      @click.prevent="
                        openTeamAttachmentsModal({
                          name: question.requestedBy.name,
                          attachments: question.attachments,
                        })
                      "
                      aria-label="Team's Attachments"
                    >
                      <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>Team’s Attachment(s)
                    </button>
                  </div>
                  <div class="marginTop10">
                    {{ question.freestyle }}
                  </div>
                </div>
              </div>
              <div
                class="marginTop20"
                v-if="test.clarificationStatus == 'released'"
              >
                <div class="control-label">TEAMS ASSIGNED</div>
                <div
                  class="marginTop10"
                  v-for="(team, team_idx) in question.assignedTo"
                >
                  <button
                    v-if="team.uuid != test.myProgression.team.uuid"
                    class="btn gradient btn-default subBtn"
                    @click.prevent="openTeamInfoModal(team)"
                    :aria-label="team.name"
                  >
                    <i class="fa fa-users marginRight8" aria-hidden="true"></i>{{ team.name }}
                    <!--<i class="fas fa-times"></i>-->
                  </button>
                  <button
                    v-else
                    class="statusTag statusTagLightWarning subBtn"
                    @click.prevent="openTeamInfoModal(team)"
                    :aria-label="team.name"
                  >
                    <i class="fa fa-users greyText marginRight8" aria-hidden="true"></i>{{ team.name }}
                    <!--<i class="fas fa-times"></i>-->
                  </button>
                </div>
                <template
                  v-if="
                    !question.assignedTo ||
                      (question.assignedTo && question.assignedTo.length == 0)
                  "
                >
                  NO TEAMS ASSIGNED
                </template>
              </div>
            </div>
          </div>


          <div class="table-responsive">
            <table class="hidden-xs hidden-sm table">
              <thead>
                <tr>
                  <th style="width: 5%"></th>
                  <th style="width: 30%">AREAS THAT NEED CLARIFICATION</th>
                  <th>ANSWERS CHOICES IN SEQUENCE</th>
                  <th style="width: 25%">WE WOULD LIKE TO CLARIFY…</th>
                  <th style="width: 144px">MY TEAM HAS…</th>
                  <th style="width: 125px" v-if="canEditClarifications">
                    ACTIONS
                  </th>
                  <th
                    style="width: 146px"
                    v-if="test.clarificationStatus == 'released'"
                  >
                    ASSIGNED TEAMS
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(question, question_idx) in clarified_questions">
                  <tr>
                    <td>
                      <div
                        v-if="question._type == 'question'"
                        style="text-align: center"
                      >
                        <template v-if="question.studentAnswer.isBookmarked">
                          <i class="bookmarked fa fa-bookmark fa-3x"></i>
                        </template>
                      </div>
                    </td>
                    <td>
                      <div v-if="question._type == 'question'">
                        <button
                          class="btn gradient btn-default subBtn"
                          @click.prevent="openQuestionInfoModal(question)"
                          :aria-label="`Question ${question.question_no}`"
                        >
                          Question {{ question.question_no }}<i
                            class="fa fa-info-circle marginLeft8" aria-hidden="true"
                          ></i>
                        </button>
                        <kr-math
                          class="marginTop10"
                          :input="question.question"
                          :safe="!question.questionIsHTML"
                        ></kr-math>
                        <!--<div class="marginTop10 fontBold">
                            Read More&nbsp;<i class="fa fa-caret-right"></i>
                          </div>-->
                      </div>
                      <div v-else>
                        <span class="btn gradient btn-default subBtn">
                          Freestyle
                        </span>
                        <div class="alert alert-primary marginTop10">
                          <div>
                            <i class="fa fa-info-circle marginRight8" aria-hidden="true"></i>
                          </div>
                          <span>
                            For freestyle clarification, you may type in any
                            clarifying questions
                            <!--OR vote for questions raised by other teams if your team has a similar question about the test.-->
                          </span>
                          <div>
                            <button
                              type="button"
                              class="close"
                              data-dismiss="modal"
                              aria-label="Close Modal"
                            >
                              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="
                          question._type == 'question' &&
                            (question.studentAnswer.attempts
                              ? question.studentAnswer.attempts.length != 0
                              : false)
                        "
                        class="statusTag subBtn"
                        :class="{
                          tagCorrect: question.percent == 100,
                          tagPrimary:
                            question.percent >= 50 && question.percent < 100,
                          tagWarning:
                            question.percent < 50 && question.percent > 0,
                          tagIncorrect: question.percent == 0,
                        }"
                      >
                        <template
                          v-for="(key, idx) in question.studentAnswer.attempts"
                        >
                          {{ key }}&nbsp;
                        </template>
                      </div>
                    </td>
                    <td>
                      <template v-if="test.clarificationStatus != 'released'">
                        <template v-if="question._type == 'question'">
                          <div
                            class="
                              flex
                              align-items
                              marginBottom20
                              col-xs-12 col-md-12
                            "
                            v-if="
                              question.studentAnswer.attachments &&
                                question.studentAnswer.attachments.length != 0
                            "
                          >
                            <div class="col-xs-12">
                              <!-- <span style="font-weight:bold;">Uploaded Files</span> -->
                              <div
                                v-for="(file, idx) in question.studentAnswer
                                  .attachments"
                                class="flexSpaceBetween"
                              >
                                <div>
                                  <span>{{ idx + 1 }}.</span>
                                  <span>
                                    <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                  </span>
                                  <a
                                    :href="file.url"
                                    target="_blank"
                                    download
                                    :aria-label="file.filename"
                                    >{{ file.filename }}</a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-if="question._type == 'freestyle'">
                          <div
                            class="
                              flex
                              align-items
                              marginBottom20
                              col-xs-12 col-md-12
                            "
                            v-if="
                              question.attachments &&
                                question.attachments.length != 0
                            "
                          >
                            <div class="col-xs-12">
                              <!-- <span style="font-weight:bold;">Uploaded Files</span> -->
                              <div
                                v-for="(file, idx) in question.attachments"
                                class="flexSpaceBetween"
                              >
                                <div>
                                  <span>{{ idx + 1 }}.</span>
                                  <span>
                                    <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                  </span>
                                  <a
                                    :href="file.url"
                                    target="_blank"
                                    download
                                    :aria-label="file.filename"
                                    >{{ file.filename }}</a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-if="question._type == 'question'">
                          <span
                            v-if="question.studentAnswer.clarifications"
                            class="whiteSpacePreLine marginRight20"
                            >{{ question.studentAnswer.clarifications }}</span
                          >
                        </template>
                        <template v-else>
                          <span
                            v-if="question.freestyle"
                            class="whiteSpacePreLine marginRight20"
                            >{{ question.freestyle }}</span
                          >
                        </template>
                        <!-- <a v-if="question._status!='voted'&&canEditClarifications" @click.prevent="question._edit=true;clarified_questions.splice()">EDIT</a> -->
                        <span
                          v-if="
                            question._status != 'voted' &&
                              !(!question._status && !canEditClarifications)
                          "
                        >
                          <template v-if="canEditClarifications">
                            <button
                              v-if="question._status"
                              class="btn btn-primary subBtn"
                              @click.prevent="openRequestModal(question)"
                              aria-label="Edit"
                            >
                              <i class="fa fa-edit" aria-hidden="true"></i>
                            </button>
                            <button
                              v-else
                              class="btn btn-primary subBtn"
                              @click.prevent="openRequestModal(question)"
                              aria-label="Request"
                            >
                              Request
                            </button>
                          </template>
                          <template v-else>
                            <button
                              v-if="question._status"
                              class="btn btn-primary subBtn"
                              @click.prevent="openRequestModal(question)"
                              aria-label="View"
                            >
                              <i class="fas fa-eye" aria-hidden="true"></i>
                            </button>
                          </template>
                        </span>
                      </template>
                      <template v-else>
                        <template v-if="question._type == 'question'">
                          <span class="btn gradient btn-default-border-primary">
                            {{
                              (question._status == "requested" ? 1 : 0) +
                                question.otherClarifications.length
                            }}
                            TEAM<template
                              v-if="
                                (question._status == 'requested' ? 1 : 0) +
                                  question.otherClarifications.length >
                                  1
                              "
                            >
                              S
                            </template>
                          </span>
                          <template v-if="question._status == 'requested'">
                            <div class="marginTop20">
                              <div
                                :class="{
                                  buttonGroup:
                                    question.studentAnswer.attachments &&
                                    question.studentAnswer.attachments.length !=
                                      0,
                                }"
                              >
                                <button
                                  class="
                                    statusTag
                                    statusTagLightWarning
                                    subBtn
                                    whiteSpaceNowrap
                                  "
                                  @click.prevent="
                                    openTeamInfoModal(test.myProgression.team)
                                  "
                                >
                                  <i class="fa fa-users greyText marginRight8" aria-hidden="true"></i>
                                  {{ test.myProgression.team.name }}
                                </button>
                                <button
                                  v-if="
                                    question.studentAnswer.attachments &&
                                      question.studentAnswer.attachments.length !=
                                        0
                                  "
                                  class="
                                    btn
                                    gradient
                                    btn-default
                                    subBtn
                                    whiteSpaceNowrap
                                  "
                                  @click.prevent="
                                    openTeamAttachmentsModal({
                                      name: test.myProgression.team.name,
                                      attachments:
                                        question.studentAnswer.attachments,
                                    })
                                  "
                                  aria-label="Team's Attachments"
                                >
                                  <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>Team’s
                                  Attachment(s)
                                </button>
                              </div>
                              <div class="marginTop10">
                                {{ question.studentAnswer.clarifications }}
                              </div>
                            </div>
                          </template>
                          <template
                            v-for="(request,
                            request_idx) in question.otherClarifications"
                          >
                            <div class="marginTop20">
                              <div
                                :class="{
                                  buttonGroup:
                                    request.attachments &&
                                    request.attachments.length != 0,
                                }"
                              >
                                <button
                                  class="
                                    btn
                                    gradient
                                    btn-default
                                    subBtn
                                    whiteSpaceNowrap
                                  "
                                  @click.prevent="openTeamInfoModal(request)"
                                  :aria-label="request.team"
                                >
                                  {{ request.team }}
                                </button>
                                <button
                                  v-if="
                                    request.attachments &&
                                      request.attachments.length != 0
                                  "
                                  class="
                                    btn
                                    gradient
                                    btn-default
                                    subBtn
                                    whiteSpaceNowrap
                                  "
                                  @click.prevent="
                                    openTeamAttachmentsModal({
                                      name: request.team,
                                      attachments: request.attachments,
                                    })
                                  "
                                  aria-label="Team's Attachments"
                                >
                                  <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>Team’s
                                  Attachment(s)
                                </button>
                              </div>
                              <div class="marginTop10">
                                {{ request.clarifications }}
                              </div>
                            </div>
                          </template>
                        </template>
                      </template>
                      <template
                        v-if="
                          test.clarificationStatus == 'released' &&
                            question._type == 'freestyle'
                        "
                      >
                        <span class="btn gradient btn-default-border-primary">
                          1 TEAM
                        </span>
                        <div class="marginTop20">
                          <div
                            :class="{
                              buttonGroup:
                                question.attachments &&
                                question.attachments.length != 0,
                            }"
                          >
                            <button
                              v-if="
                                question.requestedBy.uuid !=
                                  test.myProgression.team.uuid
                              "
                              class="
                                btn
                                gradient
                                btn-default
                                subBtn
                                whiteSpaceNowrap
                              "
                              @click.prevent="
                                openTeamInfoModal(question.requestedBy)
                              "
                              :aria-label="question.requestedBy.name"
                            >
                              {{ question.requestedBy.name }}
                            </button>
                            <span
                              v-else
                              class="
                                statusTag
                                statusTagLightWarning
                                subBtn
                                whiteSpaceNowrap
                              "
                              @click.prevent="
                                openTeamInfoModal(question.requestedBy)
                              "
                            >
                              <i class="fa fa-users greyText marginRight8" aria-hidden="true"></i>
                              {{ question.requestedBy.name }}
                            </span>
                            <button
                              v-if="
                                question.attachments &&
                                  question.attachments.length != 0
                              "
                              class="btn gradient btn-default subBtn flex1"
                              @click.prevent="
                                openTeamAttachmentsModal({
                                  name: question.requestedBy.name,
                                  attachments: question.attachments,
                                })
                              "
                              aria-label="Team's Attachments"
                            >
                              <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>Team’s
                              Attachment(s)
                            </button>
                          </div>

                          <div class="marginTop10">
                            {{ question.freestyle }}
                          </div>
                        </div>
                      </template>
                    </td>
                    <td>
                      <div class="fontBold flexOnly" v-if="question._status">
                        <i class="fa fa-check-circle textSuccess marginRight8" aria-hidden="true"></i>
                        <template v-if="question._status == 'requested'">
                          <span> Requested </span>
                        </template>
                        <template v-if="question._status == 'voted'">
                          <span> Voted </span>
                        </template>
                      </div>
                    </td>
                    <td v-if="canEditClarifications">
                      <div
                        class="hidden-xs hidden-sm buttonGroup"
                        v-if="question._status"
                      >
                        <button
                          class="btn btn-danger subBtn"
                          @click.prevent="openDeleteClarificationModal(question)"
                          aria-label="Remove"
                        >
                          Remove<i class="fa fa-trash marginLeft8" aria-hidden="true"></i>
                        </button>
                      </div>
                      <div
                        class="hidden-md hidden-lg buttonGroup"
                        v-if="question._status"
                      >
                        <button
                          class="btn btn-danger subBtn"
                          @click.prevent="openDeleteClarificationModal(question)"
                          aria-label="Remove"
                        >
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                    </td>
                    <td v-if="test.clarificationStatus == 'released'">
                      <div
                        class="multiselect marginTop10"
                        v-for="(team, team_idx) in question.assignedTo"
                      >
                        <button
                          v-if="team.uuid != test.myProgression.team.uuid"
                          class="col-xs-12 btn gradient btn-default subBtn"
                          @click.prevent="openTeamInfoModal(team)"
                          :aria-label="team.name"
                        >
                          <i class="fa fa-users marginRight8" aria-hidden="true"></i>
                          {{ team.name }}
                          <!--<i class="fas fa-times"></i>-->
                        </button>
                        <div
                          v-else
                          class="statusTag statusTagLightWarning subBtn"
                          @click.prevent="openTeamInfoModal(team)"
                          :aria-label="team.name"
                        >
                          <i class="fa fa-users greyText marginRight8" aria-hidden="true"></i>
                          {{ team.name }}
                          <!--<i class="fas fa-times"></i>-->
                        </div>
                        <template
                          v-if="
                            !question.assignedTo ||
                              (question.assignedTo &&
                                question.assignedTo.length == 0)
                          "
                        >
                          NO TEAMS ASSIGNED
                        </template>
                      </div>
                    </td>
                  </tr>
                </template>
                <tr v-if="clarified_questions.length == 0">
                  <td colspan="6" style="text-align: center">
                    NO CLARIFIED QUESTIONS
                  </td>
                </tr>
                <tr v-if="canEditClarifications">
                  <td></td>
                  <td></td>

                  <td></td>
                  <td>
                    <button
                      class="btn btn-primary subBtn"
                      @click.prevent="openRequestModal(add_question)"
                      aria-label="New Freestyle"
                    >
                      <i class="fas fa-plus marginRight8" aria-hidden="true"></i>NEW FREESTYLE
                    </button>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="marginTop20 textAlignCenter">
            <h2>Interested to learn more?</h2>
            <a href="https://www.intedashboard.com/book-a-demo" class="btn btn-success">Book a demo</a>
          </div>
        </template>
      </kr-panel>
    </div>

    <div id="voteModal" class="modal" 
      tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4 class="modal-title">Add Clarification</h4>
          </div>
          <div class="modal-body">
            <div class="flex">
              <template
                v-for="(clarification, idx) in test.clarifications.freestyles"
              >
                <div
                  class="clarificationPanel col-xs-12 col-md-6"
                  v-if="!clarification.isRequestedByMe"
                >
                  <div class="clarification-panel">
                    <div class="header">
                      <span>
                        {{ clarification.votedBy.length }}
                      </span>
                      <span>VOTES</span><i class="fa fa-thumbs-up marginLeft8" aria-hidden="true"></i>
                    </div>
                    <div class="body">
                      <div class="content">
                        <p>{{ clarification.freestyle }}</p>
                      </div>
                      <div class="footer flexRight">
                        <div
                          class="col-xs-3 buttonGroup"
                          v-if="clarification.isVotedByMe"
                        >
                          <button
                            class="btn btn-warning mainBtn"
                            @click.prevent="
                              toggleVoteClarifications(clarification)
                            "
                            aria-label="Unvote"
                          >
                            Unvote
                          </button>
                        </div>
                        <div class="col-xs-3 buttonGroup" v-else>
                          <button
                            class="btn btn-success mainBtn"
                            @click.prevent="
                              toggleVoteClarifications(clarification)
                            "
                            aria-label="Vote"
                          >
                            Vote
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <!-- 
								<div v-if="!clarification.isRequestedByMe" class="col-xs-12 col-md-6">
									<div class="clarification-panel">
										<div class="header">
											<span style="font-size:30px;margin-left:10px">
											{{clarification.votedBy.length}}
											</span>&nbsp;<span style="font-size:14px;">Votes</span>&nbsp; <i class="fa fa-flag"></i>
										</div>
										<div class="body">
											<div class="content">
												<p>{{clarification.freestyle}}</p>
											</div>
											<div class="footer">
												<div class="col-xs-12" style="padding:0;" v-if="!clarification.isVotedByMe">
												<button class="btn btn-action" style="background-color:#e69618;color:white;margin:0;height:36px;" @click.prevent="toggleVoteClarifications(clarification)">Vote for this!
												</button>
											</div>
											<div class="col-xs-12" style="padding:0;" v-else>
												<button class="btn btn-action" style="background-color:white;color:#e69618;border: 1px solid #e69618;margin:0;height:36px;margin-right:10px;">Great! your team has voted for this!
												</button>
												<button class="btn btn-action" style="background-color:#9b9f9f;color:white;margin:0;height:36px;"  @click.prevent="toggleVoteClarifications(clarification)">Unvote
												</button>
											</div>	
											</div>
										</div>
									</div>
								</div>	
							</template> -->
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
    <div
      id="clarificationRequestModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      style="z-index: 50001 !important"
    >
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4 class="modal-title">
              View Question
            </h4>
          </div>
          <div class="modal-body">
            <div class="flex">
              <div class="col-xs-12 col-md-6 paddingRight10">
                <template v-if="crudRequest._type == 'question'">
                  <question-display
                    :question="crudRequest"
                    :options="{ showCorrectAnswer: false }"
                  ></question-display>
                </template>
                <template v-else>
                  <button class="btn gradient btn-default subBtn">
                    Freestyle
                  </button>
                  <div class="alert alert-primary marginTop10">
                    <div>
                      <i class="fa fa-info-circle marginRight8" aria-hidden="true"></i>
                    </div>
                    <span>
                      For freestyle clarification, you may type in any
                      clarifying questions OR vote for questions raised by other
                      teams if your team has a similar question about the test.
                    </span>
                    <div>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close Modal"
                      >
                        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </template>
              </div>
              <div class="hidden-xs hidden-sm col-md-6">
                <template v-if="crudRequest._type == 'question'">
                  <div class="marginBottom15">
                    <div class="control-label">ANSWERS CHOICES IN SEQUENCE</div>
                    <div
                      v-if="
                        crudRequest.studentAnswer.attempts
                          ? crudRequest.studentAnswer.attempts.length != 0
                          : false
                      "
                      class="statusTag subBtn"
                      :class="{
                        tagCorrect: crudRequest.percent == 100,
                        tagPrimary:
                          crudRequest.percent >= 50 &&
                          crudRequest.percent < 100,
                        tagWarning:
                          crudRequest.percent < 50 && crudRequest.percent > 0,
                        tagIncorrect: crudRequest.percent == 0,
                      }"
                    >
                      <template
                        v-for="(key, idx) in crudRequest.studentAnswer.attempts"
                      >
                        {{ key }}&nbsp;
                      </template>
                    </div>
                    <template v-else> - </template>
                  </div>
                </template>
                <!-- <div class="row">
	    							<button v-if="add_question.type=='freestyle'" class="btn btn-default mainBtn" @click.prevent="openVoteModal(question)">Vote for Other Teams Clarification</button> -->
                <!--<a v-if="add_question.type=='freestyle'" href="#" class="link fontBold" @click.prevent="openVoteModal(add_question.question)">
	    								Vote Other Teams Clarification
	    							</a>
	    						</div>-->
                <div class="clarifyPanel">
                  <div
                    class="flex align-items marginBottom20 col-xs-12"
                    v-if="
                      crudRequest._attachments &&
                        crudRequest._attachments.length != 0
                    "
                  >
                    <div class="col-xs-12">
                      <!-- <span style="font-weight:bold;">Uploaded Files</span> -->
                      <div
                        v-for="(file, idx) in crudRequest._attachments"
                        class="flexSpaceBetween"
                      >
                        <div>
                          <span>{{ idx + 1 }}.</span>
                          <span>
                            <i class="fa fa-file-image-o" aria-hidden="true"></i>
                          </span>
                          <a
                            :href="file.url"
                            target="_blank"
                            download
                            :aria-label="file.filename"
                            >{{ file.filename }}</a
                          >
                        </div>
                        <div>
                          <span
                            @click.prevent="deleteAttachment(crudRequest, idx)"
                            class="important"
                            aria-label="Delete"
                          >
                            <i class="fa fa-trash" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clarifyBody">
                    <textarea
                      v-model="crudRequest._clarifications"
                      :disabled="!canEditClarifications"
                      rows="5"
                      cols="3"
                      class="form-control"
                      placeholder="Type clarification here…"
                    />
                  </div>
                  <div class="clarifyFooter flexSpaceBetween align-items">
                    <a
                      href="#"
                      class="link"
                      @click.prevent="addAttachments(crudRequest)"
                      v-show="canEditClarifications"
                    >
                      <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>Add Attachments
                    </a>
                    <div>
                      <template v-if="crudRequest.uuid">
                        <button
                          v-if="crudRequest._type == 'question'"
                          class="btn btn-primary subBtn"
                          :disabled="!canSubmitClarification(crudRequest)"
                          @click.prevent="updateClarifications(crudRequest)"
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                        <button
                          v-if="crudRequest._type == 'freestyle'"
                          class="btn btn-primary subBtn"
                          :disabled="!canSubmitClarification(crudRequest)"
                          @click.prevent="updateClarifications(crudRequest)"
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                        <button
                          v-if="canEditClarifications"
                          :disabled="!crudRequest._status"
                          class="btn btn-danger subBtn"
                          @click.prevent="
                            openDeleteClarificationModal(crudRequest)
                          "
                          data-dismiss="modal"
                          aria-label="Delete"
                        >
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </template>
                      <template v-else>
                        <button
                          v-if="crudRequest._type == 'question'"
                          class="btn btn-primary subBtn"
                          :disabled="!canSubmitClarification(crudRequest)"
                          @click.prevent="addClarifications(crudRequest)"
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                        <button
                          v-if="crudRequest._type == 'freestyle'"
                          class="btn btn-primary subBtn"
                          :disabled="!canSubmitClarification(crudRequest)"
                          @click.prevent="addClarifications(crudRequest)"
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hidden-md hidden-lg col-xs-12 marginTop20">
                <template v-if="crudRequest._type == 'question'">
                  <div class="marginBottom15">
                    <div class="control-label">ANSWERS CHOICES IN SEQUENCE</div>
                    <div
                      v-if="
                        crudRequest.studentAnswer.attempts
                          ? crudRequest.studentAnswer.attempts.length != 0
                          : false
                      "
                      class="statusTag subBtn"
                      :class="{
                        tagCorrect: crudRequest.percent == 100,
                        tagPrimary:
                          crudRequest.percent >= 50 &&
                          crudRequest.percent < 100,
                        tagWarning:
                          crudRequest.percent < 50 && crudRequest.percent > 0,
                        tagIncorrect: crudRequest.percent == 0,
                      }"
                    >
                      <template
                        v-for="(key, idx) in crudRequest.studentAnswer.attempts"
                      >
                        {{ key }}&nbsp;
                      </template>
                    </div>
                    <template v-else> - </template>
                  </div>
                </template>
                <!-- <div class="row">
	    							<button v-if="add_question.type=='freestyle'" class="btn btn-default mainBtn" @click.prevent="openVoteModal(question)">Vote for Other Teams Clarification</button> -->
                <!--<a v-if="add_question.type=='freestyle'" href="#" class="link fontBold" @click.prevent="openVoteModal(add_question.question)">
	    								Vote Other Teams Clarification
	    							</a>
	    						</div>-->
                <div class="clarifyPanel">
                  <div
                    class="flex align-items marginBottom20 col-xs-12"
                    v-if="
                      crudRequest._attachments &&
                        crudRequest._attachments.length != 0
                    "
                  >
                    <div class="col-xs-12">
                      <!-- <span style="font-weight:bold;">Uploaded Files</span> -->
                      <div
                        v-for="(file, idx) in crudRequest._attachments"
                        class="flexSpaceBetween"
                      >
                        <div>
                          <span>{{ idx + 1 }}.</span>
                          <span>
                            <i class="fa fa-file-image-o" aria-hidden="true"></i>
                          </span>
                          <a
                            :href="file.url"
                            target="_blank"
                            download
                            :aria-label="file.filename"
                            >{{ file.filename }}</a
                          >
                        </div>
                        <div>
                          <span
                            @click.prevent="deleteAttachment(crudRequest, idx)"
                            class="important"
                            aria-label="Delete"
                          >
                            <i class="fa fa-trash" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clarifyBody">
                    <textarea
                      v-model="crudRequest._clarifications"
                      :disabled="!canEditClarifications"
                      rows="5"
                      cols="3"
                      class="form-control"
                      placeholder="Type clarification here…"
                    />
                  </div>
                  <div class="clarifyFooter flexSpaceBetween align-items">
                    <a
                      href="#"
                      class="link"
                      @click.prevent="addAttachments(crudRequest)"
                      v-show="canEditClarifications"
                    >
                      <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>Add Attachments
                    </a>
                    <div>
                      <template v-if="crudRequest.uuid">
                        <button
                          v-if="crudRequest._type == 'question'"
                          class="btn btn-primary subBtn"
                          :disabled="!canSubmitClarification(crudRequest)"
                          @click.prevent="updateClarifications(crudRequest)"
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                        <button
                          v-if="crudRequest._type == 'freestyle'"
                          class="btn btn-primary subBtn"
                          :disabled="!canSubmitClarification(crudRequest)"
                          @click.prevent="updateClarifications(crudRequest)"
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                        <button
                          v-if="canEditClarifications"
                          :disabled="!crudRequest._status"
                          class="btn btn-danger subBtn"
                          @click.prevent="
                            openDeleteClarificationModal(crudRequest)
                          "
                          data-dismiss="modal"
                          aria-label="Delete"
                        >
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </template>
                      <template v-else>
                        <button
                          v-if="crudRequest._type == 'question'"
                          class="btn btn-primary subBtn"
                          :disabled="!canSubmitClarification(crudRequest)"
                          @click.prevent="addClarifications(crudRequest)"
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                        <button
                          v-if="crudRequest._type == 'freestyle'"
                          class="btn btn-primary subBtn"
                          :disabled="!canSubmitClarification(crudRequest)"
                          @click.prevent="addClarifications(crudRequest)"
                          aria-label="Submit"
                        >
                          Submit
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 buttonGroup marginTop30">
              <button
                class="btn btn-default mainBtn"
                data-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <!-- <div style="font-weight:bold;font-size:12px;text-align:left;">QUESTION LAST UPDATED ON</div>
			      	<div style="font-size:14px;text-align:left;margin-top:10px;">{{convertToReadableDate(previewQuestion.lastModified,'LLLL').date}}</div>
			      	<div style="margin-top:20px;" v-if="!previewQuestion.isTrashed">
				        <button @click.prevent="editQuestion(previewQuestion)" class="btn btn-secondary btn-action hidden-xs hidden-sm modalEditBtn" style="width:70%;line-height:1;padding:10px;margin:0;" data-dismiss="modal"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit Question</button>
				        <button class="btn btn-danger hidden-xs hidden-sm" style="width:28%;height:36px;" @click.prevent="remove(previewQuestion.uuid)"><i class="fa fa-trash-o"></i> Delete</button>
				         <button @click.prevent="editQuestion(previewQuestion)" class="btn btn-secondary btn-action hidden-md hidden-lg modalEditBtn" style="width:100%;line-height:1;padding:10px;margin-bottom:10px;"><i class="fa fa-pencil-square-o" aria-hidden="true" data-dismiss="modal"></i> Edit Question</button>
				        <button class="btn deleteBtn hidden-md hidden-lg" style="width:100%;height:36px;" @click.prevent="remove(previewQuestion.uuid)"><i class="fa fa-trash-o"></i> Delete</button>
				    </div>
				    <div style="margin-top:20px;" v-else>
				        <button class="btn btn-outline-info btn-action" style="width:100%;line-height:1;padding:10px;;margin-bottom:10px;" @click.prevent="reinstate(previewQuestion.uuid)"><i class="fa fa-refresh" aria-hidden="true"></i> Reinstate</button>
				    </div> -->
          </div>
        </div>
      </div>
    </div>
    <div
      id="clarificationQuestionInfoModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      style="z-index: 50001 !important"
    >
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4 class="modal-title">
              View Question
            </h4>
          </div>
          <div class="modal-body">
            <div class="flex">
              <div class="col-xs-12 col-md-6">
                <question-display
                  :question="previewQuestion"
                  :options="{ showCorrectAnswer: false }"
                ></question-display>
              </div>
              <div
                class="hidden-xs hidden-sm col-md-6"
                v-if="previewQuestion._type == 'question'"
              >
                <div class="control-label">ANSWERS CHOICES IN SEQUENCE</div>
                <div
                  v-if="
                    previewQuestion.studentAnswer.attempts
                      ? previewQuestion.studentAnswer.attempts.length != 0
                      : false
                  "
                  class="statusTag subBtn"
                  :class="{
                    tagCorrect: previewQuestion.percent == 100,
                    tagPrimary:
                      previewQuestion.percent >= 50 &&
                      previewQuestion.percent < 100,
                    tagWarning:
                      previewQuestion.percent < 50 &&
                      previewQuestion.percent > 0,
                    tagIncorrect: previewQuestion.percent == 0,
                  }"
                >
                  <template
                    v-for="(key, idx) in previewQuestion.studentAnswer.attempts"
                  >
                    {{ key }}&nbsp;
                  </template>
                </div>
                <template v-else> - </template>
              </div>
              <div
                class="hidden-md hidden-lg col-xs-12 marginTop20"
                v-if="previewQuestion._type == 'question'"
              >
                <div class="control-label">ANSWERS CHOICES IN SEQUENCE</div>
                <div
                  v-if="
                    previewQuestion.studentAnswer.attempts
                      ? previewQuestion.studentAnswer.attempts.length != 0
                      : false
                  "
                  class="statusTag subBtn"
                  :class="{
                    tagCorrect: previewQuestion.percent == 100,
                    tagPrimary:
                      previewQuestion.percent >= 50 &&
                      previewQuestion.percent < 100,
                    tagWarning:
                      previewQuestion.percent < 50 &&
                      previewQuestion.percent > 0,
                    tagIncorrect: previewQuestion.percent == 0,
                  }"
                >
                  <template
                    v-for="(key, idx) in previewQuestion.studentAnswer.attempts"
                  >
                    {{ key }}&nbsp;
                  </template>
                </div>
                <template v-else> - </template>
              </div>
            </div>

            <div class="col-xs-12 buttonGroup marginTop30">
              <button
                class="btn btn-default mainBtn"
                data-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <!-- <div style="font-weight:bold;font-size:12px;text-align:left;">QUESTION LAST UPDATED ON</div>
			      	<div style="font-size:14px;text-align:left;margin-top:10px;">{{convertToReadableDate(previewQuestion.lastModified,'LLLL').date}}</div>
			      	<div style="margin-top:20px;" v-if="!previewQuestion.isTrashed">
				        <button @click.prevent="editQuestion(previewQuestion)" class="btn btn-secondary btn-action hidden-xs hidden-sm modalEditBtn" style="width:70%;line-height:1;padding:10px;margin:0;" data-dismiss="modal"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit Question</button>
				        <button class="btn btn-danger hidden-xs hidden-sm" style="width:28%;height:36px;" @click.prevent="remove(previewQuestion.uuid)"><i class="fa fa-trash-o"></i> Delete</button>
				         <button @click.prevent="editQuestion(previewQuestion)" class="btn btn-secondary btn-action hidden-md hidden-lg modalEditBtn" style="width:100%;line-height:1;padding:10px;margin-bottom:10px;"><i class="fa fa-pencil-square-o" aria-hidden="true" data-dismiss="modal"></i> Edit Question</button>
				        <button class="btn deleteBtn hidden-md hidden-lg" style="width:100%;height:36px;" @click.prevent="remove(previewQuestion.uuid)"><i class="fa fa-trash-o"></i> Delete</button>
				    </div>
				    <div style="margin-top:20px;" v-else>
				        <button class="btn btn-outline-info btn-action" style="width:100%;line-height:1;padding:10px;;margin-bottom:10px;" @click.prevent="reinstate(previewQuestion.uuid)"><i class="fa fa-refresh" aria-hidden="true"></i> Reinstate</button>
				    </div> -->
          </div>
        </div>
      </div>
    </div>
    <div
      id="clarificationTeamInfoModal"
      class="modal"
      style="z-index: 50001 !important"
      tabindex="-1"
      role="dialog"
      aria-labelledby="clarificationTeamInfoModal-title"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4 id="clarificationTeamInfoModal-title" class="modal-title">
              View {{ previewTeam.name }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="col-xs-12">
              <ul v-for="(student, idx) in previewTeam.members">
                <li>{{ student }}</li>
              </ul>
              <ul v-for="(student, idx) in previewTeam.students">
                <li>
                  {{
                    student.firstname +
                      (student.lastname ? student.lastname : "")
                  }}
                </li>
              </ul>
            </div>
            <div class="col-xs-12 marginTop20 buttonGroup">
              <button
                class="btn btn-default mainBtn"
                data-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
    <div
      id="clarificationTeamAttachmentsModal"
      class="modal"
      style="z-index: 50001 !important"
      tabindex="-1"
      role="dialog"
      aria-labelledby="clarificationTeamAttachmentsModal-title"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4
              id="clarificationTeamAttachmentsModal-title"
              class="modal-title"
            >
              {{ previewTeam.name }} Attachments
            </h4>
          </div>
          <div class="modal-body">
            <div class="marginBottom20 col-xs-12 col-md-6">
              <div
                class="flex align-items"
                v-if="
                  previewTeam.attachments && previewTeam.attachments.length != 0
                "
              >
                <div class="col-xs-12">
                  <!-- <span style="font-weight:bold;">Uploaded Files</span> -->
                  <div
                    v-for="(file, idx) in previewTeam.attachments"
                    class="flexSpaceBetween"
                  >
                    <div>
                      <span>{{ idx + 1 }}.</span>
                      <span>
                        <i class="fa fa-file-image-o" aria-hidden="true"></i>
                      </span>
                      <a
                        :href="file.url"
                        target="_blank"
                        download
                        :aria-label="file.filename"
                        >{{ file.filename }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 buttonGroup">
              <button
                class="btn btn-default mainBtn"
                data-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
    <div
      id="clarificationRequestMoreInfoModal"
      class="modal"
      style="z-index: 50001 !important"
      tabindex="-1"
      role="dialog"
      aria-labelledby="clarificationRequestMoreInfoModal-title"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4
              id="clarificationRequestMoreInfoModal-title"
              class="modal-title"
            >
              Request Information
            </h4>
          </div>
          <div class="modal-body" v-if="previewRequest._type">
            <template v-if="previewRequest._type == 'question'">
              <button class="btn gradient btn-default-border-primary">
                {{ previewRequest.requests.length }} TEAM<template
                  v-if="previewRequest.requests.length > 1"
                  >S</template
                >
              </button>
              <template
                v-for="(request, request_idx) in previewRequest.requests"
              >
                <div class="marginTop20">
                  <div class="col-xs-6 buttonGroup">
                    <button
                      v-if="
                        request.requestedBy.uuid != test.myProgression.team.uuid
                      "
                      class="btn gradient btn-default subBtn flex1"
                      @click.prevent="openTeamInfoModal(request.requestedBy)"
                      data-dismiss="modal"
                      :aria-label="request.requestedBy.name"
                    >
                      {{ request.requestedBy.name }}
                    </button>
                    <button
                      v-else
                      class="statusTag statusTagLightWarning subBtn flex1"
                      @click.prevent="openTeamInfoModal(request.requestedBy)"
                      data-dismiss="modal"
                      :aria-label="request.requestedBy.name"
                    >
                      <i class="fa fa-users greyText marginRight8" aria-hidden="true"></i>
                      {{ request.requestedBy.name }}
                    </button>

                    <button
                      v-if="
                        request.attachments && request.attachments.length != 0
                      "
                      class="btn gradient btn-default subBtn flex1"
                      @click.prevent="
                        openTeamAttachmentsModal({
                          name: request.requestedBy.name,
                          attachments: request.attachments,
                        })
                      "
                      data-dismiss="modal"
                      aria-label="Team's Attachments"
                    >
                      <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>Team’s Attachment(s)
                    </button>
                  </div>
                  <div class="marginTop10">
                    {{ request.clarifications }}
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <button class="btn gradient btn-default-border-primary">
                {{ previewRequest.votedBy.length + 1 }} Team<template
                  v-if="previewRequest.votedBy.length > 1"
                  >s</template
                >
              </button>
              <div class="marginTop20">
                <div class="col-xs-6 buttonGroup">
                  <button
                    v-if="
                      previewRequest.requestedBy.uuid !=
                        test.myProgression.team.uuid
                    "
                    class="btn gradient btn-default subBtn flex1"
                    @click.prevent="openTeamInfoModal(question.requestedBy)"
                    data-dismiss="modal"
                    :aria-label="previewRequest.requestedBy.name"
                  >
                    {{ previewRequest.requestedBy.name }}
                  </button>
                  <button
                    v-else
                    class="statusTag statusTagLightWarning subBtn flex1"
                    @click.prevent="
                      openTeamInfoModal(previewRequest.requestedBy)
                    "
                    data-dismiss="modal"
                    :aria-label="previewRequest.requestedBy.name"
                  >
                    <i class="fa fa-users greyText marginRight8" aria-hidden="true"></i>
                    {{ previewRequest.requestedBy.name }}
                  </button>
                  <button
                    v-if="
                      previewRequest.attachments &&
                        previewRequest.attachments.length != 0
                    "
                    class="btn gradient btn-default subBtn flex1"
                    @click.prevent="
                      openTeamAttachmentsModal({
                        name: previewRequest.requestedBy.name,
                        attachments: previewRequest.attachments,
                      })
                    "
                    data-dismiss="modal"
                    aria-label="Team's Attachments"
                  >
                    <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>Team’s Attachment(s)
                  </button>
                </div>
              </div>
              <template v-for="(team, team_idx) in previewRequest.votedBy">
                <div class="marginTop20">
                  <button
                    v-if="team.name != test.myProgression.team.name"
                    class="btn gradient btn-default subBtn"
                    @click.prevent="openTeamInfoModal(team)"
                    data-dismiss="modal"
                    :aria-label="`${team.name}(Voted)`"
                  >
                    {{ team.name }}(Voted)
                  </button>
                  <div
                    v-else
                    class="statusTag statusTagLightWarning subBtn"
                    @click.prevent="openTeamInfoModal(team)"
                    :aria-label="`${team.name}(Voted)`"
                  >
                    <i class="fa fa-users greyText marginRight8" aria-hidden="true"></i>
                    {{ team.name }} (Voted)
                  </div>
                  <button
                    class="btn gradient btn-default subBtn"
                    :aria-label="`${team.name}(Voted)`"
                  >
                    {{ team.name }}(Voted)
                  </button>
                </div>
              </template>
            </template>
            <div class="col-xs-12 buttonGroup marginTop20">
              <button
                class="btn btn-default mainBtn"
                data-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="deleteClarificationModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteClarificationModal-title"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="preview modal-content">
          <div class="modal-header">
            <h4 id="deleteClarificationModal-title" class="modal-title">
              Delete Confirmation Confirmation
            </h4>
          </div>
          <div class="modal-body">
            <div>
              <div class="col-xs-12" style="text-align: center">
                <div>Are you sure you want to delete this clarification?</div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="flex">
                  <div class="col-xs-12 col-md-6">
                    <button
                      id="modal-delete-activity-btn"
                      class="btn btn-danger mainBtn"
                      style="width: 100%; padding-right: 10px"
                      @click.prevent="removeClarifications(crudRequest)"
                      data-dismiss="modal"
                      aria-label="Yes, Delete"
                    >
                      Yes, Delete
                    </button>
                  </div>
                  <div class="col-xs-12 col-md-6">
                    <button
                      id="modal-delete-activity-dismiss-btn"
                      class="btn btn-default mainBtn"
                      style="width: 100%"
                      data-dismiss="modal"
                      aria-model="No, Cancel"
                    >
                      No, Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as filestack from "filestack-js";
import KrAuth from "../../../../../components/auth/auth";
export default {
  data() {
    return {
      auth: new KrAuth(),
      component_done_loading: false,
      client: filestack.init(process.env.VUE_APP_FILESTACK_API_KEY), //filestack client
      test: {},
      display_test_proper: false,
      clarified_questions: [],
      not_clarified_questions: [],
      question: {},
      results: [],
      add_question: {
        _type: "freestyle",
        _clarifications: "",
        _attachments: [],
      },
      isTeamLeader: false,
      previewQuestion: {},
      previewTeam: {},
      previewRequest: {},
      crudRequest: {},
    };
  },
  mounted() {
    var that = this;
    this.fetchTest().then(function(response) {
      that.test = response.data.data;
      if (
        ["Lapsed", "Expired"].includes(that.auth.user().status) &&
        that.auth.user().account.paymentMethod == "Student-Paid"
      ) {
        that.$router.push({ name: "errors.403" });
      }
      that.init();
      that.component_done_loading = true;
      Vue.nextTick(function() {
        if (!_.get(that, "test.settings.allowTeamClarifications")) {
          that.$router.push({ name: "tests.index" });
        }
      });
    });
  },
  created() {
    var that = this;
    $("body")
      .addClass("test")
      .removeClass("nav-sm")
      .addClass("nav-none");
  },
  methods: {
    canSubmitClarification(question) {
      if (question.uuid) {
        if (question._type == "question") {
          if (
            question.studentAnswer.clarifications != question._clarifications ||
            !_.isEqual(
              question.studentAnswer.attachments,
              question._attachments
            )
          ) {
            return true;
          } else {
            return false;
          }
        }
        if (question._type == "freestyle") {
          if (
            question.freestyle != question._clarifications ||
            !_.isEqual(question.attachments, question._attachments)
          ) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        if (question._type == "question") {
          if (question._clarifications != "") {
            return true;
          } else {
            return false;
          }
        }
        if (question._type == "freestyle") {
          if (question._clarifications != "") {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    openDeleteClarificationModal(question = null) {
      this.crudRequest = question;
      $("#deleteClarificationModal").modal("show");
    },
    openRequestModal(question = null) {
      this.crudRequest = question;
      $("#clarificationRequestModal").modal("show");
    },
    openQuestionInfoModal(question) {
      this.previewQuestion = question;
      $("#clarificationQuestionInfoModal").modal("show");
    },
    openTeamInfoModal(team) {
      var that = this;
      this.previewTeam = team;
      $("#clarificationTeamInfoModal").modal("show");

      $("#clarificationTeamInfoModal").on("hidden.bs.modal", function() {
        that.previewTeam = {};
      });
    },
    openTeamAttachmentsModal(team) {
      var that = this;
      this.previewTeam = team;
      $("#clarificationTeamAttachmentsModal").modal("show");
      $("#clarificationTeamAttachmentsModal").on("hidden.bs.modal", function() {
        that.previewTeam = {};
      });
    },
    openRequestMoreInfoModal(request) {
      var that = this;
      this.previewRequest = request;
      $("#clarificationRequestMoreInfoModal").modal("show");
      $("#clarificationRequestMoreInfoModal").on("hidden.bs.modal", function() {
        that.previewRequest = {};
      });
    },
    processIsTeamLeader(isTeamLeader) {
      this.isTeamLeader = isTeamLeader;
    },
    isClarificationVoted(freestyle) {
      if (freestyle.isVotedByMe) {
        return true;
      }
      return false;
    },
    addAttachments(question) {
      this.client
        .picker({
          accept: [
            ".jpg",
            ".jpeg",
            ".gif",
            ".png",
            ".csv",
            ".doc",
            ".docx",
            ".dot",
            ".dotx",
            ".key",
            ".numbers",
            ".odt",
            ".odp",
            ".ods",
            ".pages",
            ".pdf",
            ".ppt",
            ".pot",
            ".potx",
            ".pps",
            ".ppsx",
            ".pub",
            ".rtf",
            ".sldx",
            ".txt",
            ".xls",
            ".xlt",
            ".xlsx",
            ".mp4",
            ".mp3",
          ],
          maxFiles: 20,
          uploadInBackground: false,
          onUploadStarted: function(file) {
            //that.is_uploading = true;
          },
          onUploadDone: function(res) {
            //that.is_uploading = false;
            if (!question._attachments) {
              question._attachments = [];
            }
            let currentLength = question._attachments.length;
            for (var i = 0; i < res.filesUploaded.length; i++) {
              _.set(
                question._attachments,
                currentLength++,
                res.filesUploaded[i]
              );
            }
            question._attachments.splice();
          },
        })
        .open();
    },
    deleteAttachment(question, idx) {
      question._attachments.splice(idx, 1);
    },
    init() {
      this.clarified_questions = [];
      this.not_clarified_questions = [];
      let count = 0;
      for (var i = 0; i < this.test.clarifications.questions.length; i++) {
        for (var j = 0; j < this.test.clarifications.questions[i].length; j++) {
          this.test.clarifications.questions[i][j].question_no = ++count;
          let clarification = _.get(
            this.test.clarifications.questions,
            i + "." + j + ".studentAnswer.clarifications",
            null
          );
          let attachments = _.get(
            this.test.clarifications.questions,
            i + "." + j + ".studentAnswer.attachments",
            null
          );
          if (!attachments) {
            attachments = [];
          }
          this.test.clarifications.questions[i][
            j
          ]._clarifications = clarification;
          this.test.clarifications.questions[i][j]._attachments = _.cloneDeep(
            attachments
          );
          this.test.clarifications.questions[i][
            j
          ].studentAnswer.attachments = attachments;
          this.test.clarifications.questions[i][j]._edit = false;
          this.test.clarifications.questions[i][j]._type = "question";
          if (clarification) {
            this.test.clarifications.questions[i][j]._status = "requested";
          } else {
            this.test.clarifications.questions[i][j]._status = "";
          }
          this.clarified_questions.push(
            _.clone(this.test.clarifications.questions[i][j])
          );
          /*if(clarification){
                			this.test.clarifications.questions[i][j]._clarifications = clarification;
                			this.test.clarifications.questions[i][j]._attachments = _.cloneDeep(attachments);
                			this.test.clarifications.questions[i][j].studentAnswer.attachments = attachments;
                			this.test.clarifications.questions[i][j]._edit = false;
          					this.test.clarifications.questions[i][j]._type = 'question';
          					this.test.clarifications.questions[i][j]._status = 'requested';
                			this.clarified_questions.push(_.clone(this.test.clarifications.questions[i][j]));
                		}else{
                			this.test.clarifications.questions[i][j]._type = 'question';
                			this.not_clarified_questions.push(_.clone(this.test.clarifications.questions[i][j]));
                		}*/
        }
      }
      for (var i = 0; i < this.test.clarifications.freestyles.length; i++) {
        let freestyle = this.test.clarifications.freestyles[i];
        let attachments = _.get(
          this.test.clarifications.freestyles,
          i + ".attachments",
          null
        );
        if (!attachments) {
          attachments = [];
        }
        if (
          freestyle.isRequestedByMe ||
          (this.test.clarificationStatus == "released" &&
            freestyle.assignedTo &&
            freestyle.assignedTo.length > 0)
        ) {
          freestyle._type = "freestyle";
          if (freestyle.isRequestedByMe) {
            freestyle._status = "requested";
          }
          freestyle._edit = false;
          freestyle._clarifications = freestyle.freestyle;
          freestyle.attachments = attachments;
          freestyle._attachments = _.cloneDeep(attachments);
          this.clarified_questions.push(_.clone(freestyle));
        } else {
          if (this.isClarificationVoted(freestyle)) {
            freestyle._type = "freestyle";
            freestyle._status = "voted";
            freestyle._edit = false;
            freestyle._clarifications = freestyle.freestyle;
            freestyle.attachments = attachments;
            freestyle._attachments = _.cloneDeep(attachments);
            this.clarified_questions.push(_.clone(freestyle));
          }
        }
      }
    },
    /*initResults(){
				this.results = [];
				for(var i = 0; i<this.test.results.questions.length;i++){
					let clarification = this.test.results.questions[i];
					clarification._type = 'question';
					this.results.push(_.clone(clarification));
				}
				for(var i = 0; i<this.test.results.freestyles.length;i++){
					let clarification = this.test.results.freestyles[i];
					clarification._type = 'freestyle';
					this.results.push(_.clone(clarification));
				}
			},*/
    //freestyle clarifications only
    toggleVoteClarifications(clarification) {
      var that = this;
      axios
        .patch(
          "student/tests/" +
            this.test.uuid +
            "/freestyles/" +
            clarification.uuid +
            "/vote"
        )
        .then(function(response) {
          that.$notify({
            group: "form",
            type: "success",
            title: "Success",
            text:
              "You have successfully toggled voting for this freestyle clarification",
          });
          //Events.fire('changed-test',response.data.data);
          that.clearAddClarificationsForm();
        });
    },
    clearAddClarificationsForm() {
      this.add_question._clarifications = "";
      this.add_question._attachments = [];
      this.add_question._type = "freestyle";
    },
    addClarifications(question) {
      var that = this;
      if (question.type == "question") {
        axios
          .post("/student/tests/" + this.test.uuid + "/clarifications", {
            userPlacementTestUuid: this.test.uuid,
            activityQuestionUuid: question.question.uuid,
            clarifications: question._clarifications,
            attachments: question._attachments,
          })
          .then(function(response) {
            that.$notify({
              group: "form",
              type: "success",
              title: "Success",
              text:
                "You have successfully added clarifications for this question",
            });
            //Events.fire('changed-test',response.data.data);
            $("#clarificationRequestModal").modal("hide");
            that.clearAddClarificationsForm();
          });
      } else {
        //freestyle
        axios
          .post("/student/tests/" + this.test.uuid + "/freestyles", {
            freestyle: question._clarifications,
            attachments: question._attachments,
          })
          .then(function(response) {
            that.$notify({
              group: "form",
              type: "success",
              title: "Success",
              text: "You have successfully added a freestyle clarification",
            });
            //Events.fire('changed-test',response.data.data);
            $("#clarificationRequestModal").modal("hide");
            that.clearAddClarificationsForm();
          });
      }
    },
    updateClarifications(question) {
      var that = this;
      if (question._type == "question") {
        axios
          .post("/student/tests/" + this.test.uuid + "/clarifications", {
            userPlacementTestUuid: this.test.uuid,
            activityQuestionUuid: question.uuid,
            clarifications: question._clarifications,
            attachments: question._attachments,
          })
          .then(function(response) {
            question._edit = false;
            that.$notify({
              group: "form",
              type: "success",
              title: "Success",
              text:
                "You have successfully updated clarifications for this question",
            });
            //Events.fire('changed-test',response.data.data);
          });
      } else {
        axios
          .patch(
            "/student/tests/" + this.test.uuid + "/freestyles/" + question.uuid,
            {
              freestyle: question._clarifications,
              attachments: question._attachments,
            }
          )
          .then(function(response) {
            question._edit = false;
            that.$notify({
              group: "form",
              type: "success",
              title: "Success",
              text: "You have successfully updated a freestyle clarification",
            });
            // Events.fire('changed-test',response.data.data);
            that.clearAddClarificationsForm();
          });
      }
    },
    removeClarifications(question) {
      var that = this;
      if (question._type == "question") {
        axios
          .delete(
            "/student/tests/" +
              this.test.uuid +
              "/clarifications/" +
              question.studentAnswer.uuid
          )
          .then(function(response) {
            that.$notify({
              group: "form",
              type: "success",
              title: "Success",
              text: "You have successfully deleted a question clarification",
            });
            //Events.fire('changed-test',response.data.data);
            that.clearAddClarificationsForm();
          });
      } else {
        if (question._status == "requested") {
          axios
            .delete(
              "/student/tests/" +
                this.test.uuid +
                "/freestyles/" +
                question.uuid
            )
            .then(function(response) {
              that.$notify({
                group: "form",
                type: "success",
                title: "Success",
                text: "You have successfully deleted a freestyle clarification",
              });
              //Events.fire('changed-test',response.data.data);
              that.clearAddClarificationsForm();
            });
        } else {
          this.toggleVoteClarifications(question);
        }
      }
    },
    openVoteModal(question) {
      this.question = question;
      $("#voteModal").modal("show");
    },
    fetchTest() {
      return axios.get(
        "student/tests/" + this.$route.params.id + "/clarifications"
      );
    },
  },
  components: {
    "test-topbar": require(`./../partials/topbar.vue`).default,
    "team-leadership": require(`./../partials/team-leadership.vue`).default,
    "question-groups": require(`./../partials/questions/question-groups.vue`)
      .default,
    "question-pagination": require(`./../partials/question-pagination.vue`)
      .default,
    "question-display": require(`./../../../questions/partials/question-display.vue`)
      .default,
  },
  computed: {
    canEditClarifications() {
      if (
        ["ongoing"].includes(this.test.clarificationStatus) &&
        this.isTeamLeader
      ) {
        return true;
      }
      return false;
    },
  },
  beforeDestroy() {
    if ($(window).width() > 991) {
      $("body")
        .removeClass("test")
        .addClass("nav-sm")
        .removeClass("nav-none");
    } else {
      $("body")
        .removeClass("test")
        .removeClass("nav-sm")
        .addClass("nav-none");
    }
    Events.off("current-question-changed");
  },
};
</script>

<style scoped>
.optionBarsDanger {
  padding: 10px;
  border-radius: 3px;
  background-color: #ad2224;
  color: #fff;
}

.clarification .dropdown-toggle,
.clarification .dropdown-menu {
  width: 100%;
}

.clarification .dropdown-menu {
  padding: 0;
  margin-top: 10px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  border: 1px solid #d8d8d8;
  padding-top: 15px;
}

.clarification .dropdown-menu .footer .btn {
  margin-top: 0;
}

.clarification .dropdown-menu .footer {
  background-image: linear-gradient(to bottom, #ffffff, #f5f7f9);
  border-top: 1px solid #d8d8d8;
  padding: 10px;
}

.clarification .dropdown-menu select {
  width: 100%;
  border: none;
  padding: 15px 15px 5px;
}

.clarification .dropdown-menu li span:first-child {
  font-size: 14px;
  font-weight: bold;
}

.clarification .dropdown-menu li.selected,
.clarification .dropdown-menu li:hover {
  background-image: linear-gradient(to bottom, #f1f4f8, #f5f7f9);
}

.clarification .dropdown-menu li.selected a,
.clarification .dropdown-menu li:hover a {
  color: #1991eb;
}

.clarification .dropdown-menu li span:last-child {
  font-size: 12px;
}

.clarification ul {
  margin: 0;
  padding: 0 0 10px;
  max-height: 100px;
  overflow: auto;
  list-style-type: none;
}

.clarification ul a {
  color: #222;
}

.clarification ul li {
  padding: 5px 15px;
  white-space: nowrap;
  overflow: hidden;
}

.clarification-panel {
  border: 1px solid #ededed;
  border-radius: 3px;
}

.clarificationPanel {
  margin-top: 20px;
}

.clarificationPanel:first-child {
  margin-top: 0;
}

.clarification-panel .header {
  padding: 10px 20px;
  background-color: #495060;
  line-height: 1;
  color: #fff;
}

.clarification-panel .header span:first-child {
  font-size: 30px;
  font-weight: bold;
}

.clarification-panel .body {
  height: 173px;
  background-color: white;
  padding: 15px !important;
}

.clarification-panel .body .content {
  height: 92px;
  display: block;
  overflow: hidden;
  overflow-y: auto;
  white-space: pre-line;
  word-wrap: break-word;
}
.clarification-panel .body .content p {
  margin: 0;
  white-space: pre-line;
  word-wrap: break-word;
}
.clarification-panel .body .footer {
  height: 56px;
  padding-top: 15px;
}

.clarification .dropdown a:hover {
  background: none;
}

.clarifyBody textarea {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.clarifyFooter {
  background-image: linear-gradient(to bottom, #ffffff, #f5f7f9);
  border: 1px solid #d8d8d8;
  padding: 10px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.clarifyFooter a.link {
  font-size: 12px;
  font-weight: bold;
}

.clarifyFooter a.link .fa {
  color: #9b9f9f;
}

.multiselect .col-xs-12.btn {
  margin-top: 15px;
}

.multiselect .col-xs-12.btn:first-child {
  margin-top: 0;
}

@media (min-width: 992px) {
  .clarificationPanel:nth-child(-n + 2) {
    margin-top: 0;
  }

  .clarificationPanel:nth-child(even) {
    padding-left: 10px;
  }

  .clarificationPanel:nth-child(odd) {
    padding-right: 10px;
  }
}

body.test .clarification .panel-body {
  height: auto;
  max-height: 364px;
}
i.fa-bookmark.bookmarked {
  color: #facd36;
}
.tagCorrect {
  background-color: #0f9b81;
  border-radius: 3px;
  color: #fff;
}

.tagIncorrect {
  background-color: #dc3c42;
  border-radius: 3px;
  color: #fff;
}
.tagPrimary {
  background-color: #546ea9;
  border-radius: 3px;
  color: #fff;
}
.tagWarning {
  background-color: #e69b23;
  border-radius: 3px;
  color: #fff;
}
#deleteClarificationModal .modal-body .row:last-child {
  margin-top: 30px;
}

#deleteClarificationModal .modal-body .row .col-md-6 {
  padding-right: 10px;
  padding-left: 0;
}
#deleteClarificationModal .modal-body .row .col-md-6:last-child {
  padding-left: 10px;
  padding-right: 0;
}
</style>

<style>
body.test .panel:last-child {
  margin-bottom: 0;
}
</style>
